import { render, staticRenderFns } from "./audioStatement.vue?vue&type=template&id=b19c45c0&scoped=true&"
import script from "./audioStatement.vue?vue&type=script&lang=js&"
export * from "./audioStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19c45c0",
  null
  
)

export default component.exports